export const OPEN_CHANGE_PASSWORD_SEARCH_PARAM = 'openChangePassword'
